import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los lomos de los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-red-500 text-white', 'bg-yellow-400 text-navy', 'bg-green-500 text-navy', 'bg-brand text-white', 'bg-violet-600 text-white', 'bg-ice text-navy'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-navy" data-id="element-151" data-mp="12hy5uat9q39">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-152" data-mp="3t7c3zyfxldc7">
        <p className="font-sub text-sm font-semibold leading-tight text-ice" data-id="element-153" data-mp="au4eg520afcv">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-154" data-mp="5w2xpqs1ys4k">
          <span className="text-ice" data-id="element-155" data-mp="fujr0uegrits">6 tomos en un solo sistema,</span> creados
          para aprender desde cero.
        </h2>
        <p className="mt-1 font-display text-xs font-extrabold uppercase leading-tight text-cta-light sm:text-sm" data-id="element-156" data-mp="36cgngwbz4i5x">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/90" data-id="element-157" data-mp="3fasl3ib9cg7v">
          No es simplemente otro ebook técnico. Es una{' '}
          <strong className="font-bold text-ice" data-id="element-158" data-mp="3kboozvvm02da">ruta de aprendizaje</strong>{' '}
          que organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo se conecta cada componente
          de un sistema de aire acondicionado automotriz.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-159" data-mp="2w035suelq44">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-ice bg-white text-left text-navy" data-id="element-160" data-mp="6upgxmjct9oa" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-161" data-mp="2cwjn4m32cuac">
                <span className="font-sub text-[10px] font-semibold uppercase tracking-wider" data-id="element-162" data-mp="27zb4ylhx0q93">
                  Tomo
                </span>
                <span className="font-display text-2xl font-black leading-none" data-id="element-163" data-mp="2hvw6uxyn1l8p">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-164" data-mp="2vlpy1mxm8hll">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-165" data-mp="2rlpks5m96cg4">
                  <span className="sr-only" data-id="element-166" data-mp="2rns8gizxntho">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-slate-600 sm:text-sm" data-id="element-167" data-mp="35j4bddo8sq9o">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-168" data-mp="1b9afsldmw7r9">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}